const CloseIcon = ({onClick, size}) => {
    const dim = size ? size : "20"
    return(
        <svg width={dim} height={dim} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} role="button">
<path d="M19 4.99988L5 18.9999M5 4.99988L19 18.9999" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    )
}

export default CloseIcon